export function addCommas (v) {
  if (typeof v === 'undefined' || v === null) {
    return '-'
  }
  return v.toLocaleString('en-US', {
    maximumFractionDigits: 4
  })
}

export function decimalFormat (num, pos) {
  var pow = Math.pow(10, pos)
  return Math.round(num * pow) / pow
}

export function ignoreDot (event) {
  let charCode = event.keyCode
  if (charCode === 46) { // 46 is dot
    event.preventDefault()
  }
}

export function parseFloatPrecision (value, precision) {
  if (isNaN(value)) {
    return value
  }

  const num = parseFloat(value)
  if (isNaN(num)) {
    return null
  }

  return parseFloat(num.toFixed(precision))
}

export function parseFloatWithComma (v) {
  if (typeof v === 'string' || v instanceof String) {
    return parseFloat(v.replaceAll(',', ''))
  }

  return parseFloat(v)
}
